<template>
	<db-row width="80%" height="auto" class="dialog-alert-wrapper" :class="alertClass">
		<db-row class="alert-body auto-fill">
			<db-col height="auto" v-if="title" align="center" class="dialog-title">{{title}}</db-col>
			<db-col class="dialog-message auto-fill" valign="middle" align="center">
				{{message}}
			</db-col>
		</db-row>
		<db-row height="auto">
			<db-button width="100%" around @click="clickHandler">我知道了</db-button>
			<!-- <db-col height="16" />
			<db-button type="danger" width="100%" around @click="clickHandler">取消</db-button> -->
		</db-row>
	</db-row>
</template>

<script>
	import {Alert} from '../../../../model/Dialog'
	
	export default {
		props: {
			title: {
				type: [String, Number],
				default: ''
			},
			
			message: {
				type: [String, Number],
				default: ''
			},
			
			handler: {
				type: Function
			}
		},
		
		data(){
			return {
				alertClass: 'alert-init'
			}
		},
		
		mounted(){
			this.start()
		},
		
		methods: {
			async start(){
				return new Promise(res => {
					setTimeout(() => {
						this.alertClass = 'alert-active'
						setTimeout(async () => {
							res()
						}, 200)
					}, 50)
				})
			},
			
			async close(){
				return new Promise(res => {
					this.alertClass = 'alert-init'
					setTimeout(() => {
						this.$store.commit('mobileStore/removeDialog')
						res()
					}, 300)
				})
			},
			
			async clickHandler(){
				if(this.handler){
					this.handler(this.close)
				}else{
					await this.close()
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.dialog-alert-wrapper{
		padding: 30px 40px;
		color: #333;
		background: rgba(#fff, 1.0);
		border-radius: 64px;
		transition: all .15s;
		min-height: 400px;
		
		&.alert-init{
			opacity: 0;
			transform: scale(.8);
		}
		&.alert-active{
			opacity: 1.0;
			transform: scale(1.0);
		}
		
		.alert-body{
			padding-bottom: 30px;
			
			.dialog-title{
				color: #333;
				font-weight: bold;
				font-size: 32px;
				padding-bottom: 24px;
			}
			
			.dialog-message{
				color: #333;
				padding: 0 30px;
				line-height: 42px;
				font-size: 32px;
				text-align: center;
			}
		}
	}
</style>